var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"dtt-status",class:_vm.classes},[(_vm.icon && !_vm.noText)?_c('DttIcon',{attrs:{"name":_vm.icon}}):_vm._e(),(!_vm.noText)?_c('DttTypo',{attrs:{"bold":"","size":_vm.textSize}},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }